export default __webpack_public_path__ + "static/media/lokalac@3x.a74de97f.png";